const storeLocations = [
  {
    name: "Innovasport Plaza Rio Plus",
    state: "Baja California",
    alcaldia: "Tijuana",
    calle: "PASEO DE LOS HEROES #9550",
    local: "B21",
    colonia: "ZONA URBANA RIO TIJUANA",
    postal_code: "22010",
    phone: "-",
    latitude: "32.5267492",
    longitude: "-117.0203991"
  },
  {
    name: "Innovasport Puerto Paraiso",
    state: "Baja California Sur",
    alcaldia: "Cabo San Lucas",
    calle: "Av. Lázaro Cárdenas #1501",
    local: "L200, 201, 203, 204, 205 y 207",
    colonia: "El Medano",
    postal_code: "23410",
    phone: "-",
    latitude: "22.8869551",
    longitude: "-109.9110444"
  },
  {
    name: "Innovasport Sendero Los Cabos",
    state: "Baja California Sur",
    alcaldia: "CABO SAN LUCAS",
    calle: "AVE. LAS BRISAS #2404",
    local: "-",
    colonia: "Col. BRISAS DEL PACIFICO",
    postal_code: "23473",
    phone: "-",
    latitude: "22.9041891",
    longitude: "-109.9340279"
  },
  {
    name: "Innovasport Fashion Mall Chihuahua",
    state: "Chihuahua",
    alcaldia: "Chihuahua",
    calle: "Periferico de la Juventud #3501",
    local: "S 01",
    colonia: "Fracc. Puerta de Hierro",
    postal_code: "31207",
    phone: "-",
    latitude: "28.6227169",
    longitude: "-106.1149539"
  },
  {
    name: "Run and Run",
    state: "CDMX",
    alcaldia: "Álvaro Obregón",
    calle: "Insurgentes Sur 1971 - 280",
    local: "-",
    colonia: "Guadalupe Inn",
    postal_code: "01020",
    phone: "-",
    latitude: "19.3519899",
    longitude: "-99.186393"
  },
  {
    name: "Innovasport Parque Delta",
    state: "CDMX",
    alcaldia: "Benito Juarez",
    calle: "Av. Cuauhtemoc #462",
    local: "L211, L212, L213A, L213B y L214",
    colonia: "Narvarte",
    postal_code: "03020",
    phone: "-",
    latitude: "19.402948",
    longitude: "-99.1562827"
  },
  {
    name: "Innovasport Oasis Plus",
    state: "CDMX",
    alcaldia: "Coyoacán",
    calle: "AV. UNIVERSIDAD #1778",
    local: "PA-28",
    colonia: "ROMERO DE TERREROS",
    postal_code: "04310",
    phone: "-",
    latitude: "19.3455693",
    longitude: "-99.1816185"
  },
  {
    name: "Innovasport Santa Fe",
    state: "CDMX",
    alcaldia: "Cuajimalpa de Morelos",
    calle: "Av. Vasco de Quiroga #3850",
    local: "INT 1180",
    colonia: "Santa Fe",
    postal_code: "05348",
    phone: "55 2167 8227",
    latitude: "19.3647464",
    longitude: "-99.276034"
  },
  {
    name: "Innovasport Interlomas Plus",
    state: "CDMX",
    alcaldia: "HUIXQUILUCAN",
    calle: "BLVD. INTERLOMAS #5",
    local: "-",
    colonia: "Col. San Fernando la Herradura",
    postal_code: "52787",
    phone: "-",
    latitude: "19.401998",
    longitude: "-99.2728407"
  },
  {
    name: "Innovasport Polanco",
    state: "CDMX",
    alcaldia: "Miguel Hidalgo",
    calle: "Horacio 203",
    local: "-",
    colonia: "Polanco",
    postal_code: "11560",
    phone: "-",
    latitude: "19.4335122",
    longitude: "-99.1866772"
  },
  {
    name: "Innovasport Coss",
    state: "Coahuila",
    alcaldia: "Saltillo",
    calle: "Boulevard Francisco Coss 770",
    local: "-",
    colonia: "Centro",
    postal_code: "25000",
    phone: "-",
    latitude: "25.434868",
    longitude: "-101.0030437"
  },
  {
    name: "Innovasport Independencia",
    state: "Coahuila",
    alcaldia: "Torreón",
    calle: "Blvd. Independencia 1300",
    local: "-",
    colonia: "Navarro",
    postal_code: "27010",
    phone: "-",
    latitude: "25.4348677",
    longitude: "-101.0096098"
  },
  {
    name: "Innovasport Plus Ecatepec",
    state: "Estado de México",
    alcaldia: "ECATEPEC DE MORELOS",
    calle: "AV. CENTRAL MZ4",
    local: "-",
    colonia: "Col. CONJUNTO URBANO LAS AMERICAS",
    postal_code: "55075",
    phone: "-",
    latitude: "19.2671543",
    longitude: "-99.6758705"
  },
  {
    name: "KM07 - Circunvalación 740",
    state: "Guanajuato",
    alcaldia: "León",
    calle: "Calle Circunvalación 740",
    local: "-",
    colonia: "Col. Jardines del Moral",
    postal_code: "45645",
    phone: "-",
    latitude: "21.1525436",
    longitude: "-101.6910421"
  },
  {
    name: "Deporte Hábitat",
    state: "Jalisco",
    alcaldia: "Guadalajara",
    calle: "Lerdo de Tejada #2593",
    local: "-",
    colonia: "Arcos Vallarta",
    postal_code: "44130",
    phone: "33 3615 8697",
    latitude: "20.6702408",
    longitude: "-103.3846888"
  },
  {
    name: "Innovasport La Isla",
    state: "Jalisco",
    alcaldia: "Puerto Vallarta",
    calle: "Boulevard Francisco Medina Ascencio #2479",
    local: "Interior PB-01",
    colonia: "Zona Hotelera Norte",
    postal_code: "48333",
    phone: "-",
    latitude: "20.6445345",
    longitude: "-105.2395491"
  },
  {
    name: "Innovasport Galerías Guadalajara",
    state: "Jalisco",
    alcaldia: "Zapopan",
    calle: "Av. Vallarta 5400",
    local: "-",
    colonia: "Jardines de Universidad",
    postal_code: "45110",
    phone: "-",
    latitude: "20.6810822",
    longitude: "-103.4311214"
  },
  {
    name: "Innovasport Gran Plaza",
    state: "Jalisco",
    alcaldia: "Zapopan",
    calle: "AV. VALLARTA 3959",
    local: "-",
    colonia: "Col. DON BOSCO VALLARTA",
    postal_code: "45409",
    phone: "-",
    latitude: "20.6737595",
    longitude: "-103.4072332"
  },
  {
    name: "Dopamina Sports",
    state: "Nuevo León",
    alcaldia: "Monterrey",
    calle: "Via Latina #606",
    local: "-",
    colonia: "Fuentes del Valel",
    postal_code: "66220",
    phone: "-",
    latitude: "25.6639845",
    longitude: "-100.369009"
  },
  {
    name: "Innovasport San Pedro",
    state: "Nuevo León",
    alcaldia: "Monterrey",
    calle: "Av. Humberto Lobo 540",
    local: "Del Valle",
    colonia: "San Pedro Garza García",
    postal_code: "66200",
    phone: "-",
    latitude: "25.6903303",
    longitude: "-100.4188038"
  },
  {
    name: "Innovasport Paseo La Fe Plus",
    state: "Nuevo León",
    alcaldia: "Monterrey",
    calle: "Av. Miguel Aleman 200",
    local: "SA-05 PB Y SA-14 NIVEL 1",
    colonia: "La Talaverna",
    postal_code: "66473",
    phone: "81 2168 6987",
    latitude: "25.719835",
    longitude: "-100.2214757"
  },
  {
    name: "Run 24",
    state: "Nuevo León",
    alcaldia: "Monterrey",
    calle: "Lazaro Cárdenas No. exterior 2810 Int. 6",
    local: "-",
    colonia: "La República",
    postal_code: "64900",
    phone: "81 2315 8834",
    latitude: "25.6289234",
    longitude: "-100.3009969"
  },
  {
    name: "Innovasport Antea",
    state: "Querétaro",
    alcaldia: "Querétaro",
    calle: "Carretera Querétaro San Luis Potosí 12401",
    local: "-",
    colonia: "Jurica",
    postal_code: "76100",
    phone: "-",
    latitude: "20.6746757",
    longitude: "-100.4380132"
  },
  {
    name: "Innovasport La Isla",
    state: "Quintana Roo",
    alcaldia: "Cancún",
    calle: "Blvd. Kukulcan 18-1018-11",
    local: "-",
    colonia: "Zona Hotelera",
    postal_code: "77500",
    phone: "-",
    latitude: "21.1109046",
    longitude: "-86.7662453"
  },
  {
    name: "Innovasport Las Américas",
    state: "Quintana Roo",
    alcaldia: "Cancún",
    calle: "Av. Bonampak Lote 4 y 5",
    local: "-",
    colonia: "Supermanzana 8",
    postal_code: "77500",
    phone: "-",
    latitude: "21.140804",
    longitude: "-86.831173"
  },
  {
    name: "Innovasport Puerto Cancún",
    state: "Quintana Roo",
    alcaldia: "Cancún",
    calle: "Av. Bonampak MZ 27 L1 02 UC 27 2",
    local: "Interior A-01. Sección E",
    colonia: "Benito Juarez",
    postal_code: "77500",
    phone: "-",
    latitude: "21.161197",
    longitude: "-86.8101127"
  },
  {
    name: "Innovasport 5ta Avenida",
    state: "Quintana Roo",
    alcaldia: "Playa Del Carmen",
    calle: "5ta Ave. Norte Lote #2",
    local: "-",
    colonia: "Centro",
    postal_code: "77710",
    phone: "-",
    latitude: "20.6244662",
    longitude: "-87.0758128"
  },
  {
    name: "Garox Sport",
    state: "San Luis Potosí",
    alcaldia: "San Luis Potosí",
    calle: "Av. de la Victoria #100",
    local: "Club Deportivo La Loma",
    colonia: "Fracc. La Loma",
    postal_code: "78216",
    phone: "-",
    latitude: "22.1343765",
    longitude: "-101.0420762"
  },
  {
    name: "Innovasport Altama",
    state: "Tamaulipas",
    alcaldia: "Tampico",
    calle: "Av. Ejercito Mexicano 706",
    local: "Locales 1028 a 1031",
    colonia: "Primavera",
    postal_code: "89130",
    phone: "-",
    latitude: "22.2488113",
    longitude: "-97.867264"
  },
  {
    name: "Innovasport Plaza Real Reynosa Plus",
    state: "Tamaulipas",
    alcaldia: "Reynosa",
    calle: "HIDALGO #101",
    local: "-",
    colonia: "Col. LAS FUENTES",
    postal_code: "88710",
    phone: "-",
    latitude: "26.0739549",
    longitude: "-98.3214974"
  },
  {
    name: "Innovasport Andamar",
    state: "Veracruz",
    alcaldia: "Boca del Río",
    calle: "Boulevard Ruíz Cortines 4300",
    local: "-",
    colonia: "Playa de Oro",
    postal_code: "94299",
    phone: "-",
    latitude: "19.1390553",
    longitude: "-96.1053858"
  },
  {
    name: "PERRO QUE LADRA",
    state: "Veracruz",
    alcaldia: "Xalapa",
    calle: "Leona Vicario #15",
    local: "-",
    colonia: "Centro",
    postal_code: "91000",
    phone: "2289791322",
    latitude: "19.5257241",
    longitude: "-96.9291444"
  },
  {
    name: "Innovasport Hardbord Mérida",
    state: "Yucatán",
    alcaldia: "Mérida",
    calle: "Av. Paseo de Montejo #1046",
    local: "-",
    colonia: "-",
    postal_code: "97204",
    phone: "-",
    latitude: "19.4019846",
    longitude: "-99.3406923"
  },
  {
    name: "DelMaz Marina Puerto Cancun",
    state: "Quintana Roo",
    alcaldia: "Benito Juarez",
    calle: "Blvd Kukulkán 1",
    local: "A04C Secc E",
    colonia: "Zona Holetera Cancun",
    postal_code: "77500",
    phone: "800 001 3569",
    latitude: "21.1602778",
    longitude: "-86.8086111"
  },
  {
    name: "Innovasport Contry Plus",
    state: "Nuevo León",
    alcaldia: "Monterrey",
    calle: "AVE. EUGENIO GARZA SADA #750",
    local: "15",
    colonia: "Contry",
    postal_code: "64860",
    phone: "-",
    latitude: "25.638288",
    longitude: "-100.2826301"
  },
  {
    name: 'Innovasport Galerias Saltillo',
    state: 'COAHUILA',
    alcaldia: 'SALTILLO',
    calle: 'BOULEVARD NAZARIO S. ORTIZ GARZA	2345',
    local: '171',
    colonia: 'TANQUE DE PEÑA',
    postal_code: '25279',
    phone: '',
    latitude: '25.4585865',
    longitude: '-100.9818894',
  },
  {
    name: "Innovasport Plus Artz",
    state: "Estado de México",
    alcaldia: "ALVARO OBREGON",
    calle: "ADOLFO RUIZ CORTINES #3720",
    local: "L 200 L 101",
    colonia: "JARDINES DEL PEDREGAL",
    postal_code: "1900",
    phone: "",
    latitude: "19.3144546",
    longitude: "-99.2220914",
  },
  {
    name: "Innovasport Mitikah",
    state: "Estado de México",
    alcaldia: "BENITO JUAREZ",
    calle: "AV. REAL MAYORAZGO #130",
    local: "3N 30 Y 3N 31",
    colonia: "XOCO",
    postal_code: "3330",
    phone: "",
    latitude: "19.3589003",
    longitude: "-99.1699336",
  },
  {
    name: 'Innovasport Averanda',
    state: 'Morelos',
    alcaldia: 'Cuernavaca',
    calle: 'Autopista México Acapulco 87',
    local: 'Local 5',
    colonia: 'Ricardo Flores Magon',
    postal_code: '62370',
    phone: '777 500 9125',
    latitude: '18.9353179',
    longitude: '-99.1951199',
  },
  {
    name: 'Innovasport Distrito La Perla',
    state: 'JALISCO',
    alcaldia: 'ZAPOPAN',
    calle: 'AV. MARIANO OTERO 3000',
    local: '111',
    colonia: 'CIUDAD DEL SOL',
    postal_code: '45050',
    phone: '',
    latitude: '25.444243',
    longitude: '-100.9629977',
  },
  {
    name: 'Innovasport Plaza Satélite',
    state: 'EDO. DE MÉXICO',
    alcaldia: 'NAUCALPAN DE JUÁREZ',
    calle: 'AV CIRCUITO CENTRO COMERCIAL 2251',
    local: '',
    colonia: 'CIUDAD SATÉLITE',
    postal_code: '53100',
    phone: '',
    latitude: '19.5105351',
    longitude: '-99.2358227',
  },
  {
    name: 'Innovasport Mundo E',
    state: 'Estado de México',
    alcaldia: 'TLALNEPANTLA DE BAZ',
    calle: 'BLVD. MANUEL AVILA CAMACHO	1007',
    local: 'M12',
    colonia: 'SAN LUCAS TEPETLACALCO',
    postal_code: '54055',
    phone: '',
    latitude: '19.5251608',
    longitude: '-99.2463902',
  },
  {
    name: "Innovasport Plus Andares",
    state: "Jalisco",
    alcaldia: "ZAPOPAN",
    calle: "BLVD. PUERTA DE HIERRO #5153",
    local: "02",
    colonia: "",
    postal_code: "45116",
    phone: "",
    latitude: "20.7100577",
    longitude: "-103.4482527",
  },
  {
    name: "Innovasport Península Tijuana",
    state: "BAJA CALIFORNIA",
    alcaldia: "TIJUANA",
    calle: "Calle AV. VIA RAPIDA ORIENTE #1500",
    local: "Interior SA 07",
    colonia: "CHAPULTEPEC ALAMAR",
    postal_code: "22110",
    phone: "",
    latitude: "32.5134115",
    longitude: "-116.9679893",
  },
  {
    name: 'Innovasport Parque Tepeyac',
    state: 'CIUDAD DE MEXICO',
    alcaldia: 'GUSTAVO A MADERO',
    calle: 'AV. EDUARDO MOLINA 6730',
    local: 'L48A, L48B, L49A, L49B, L50B',
    colonia: 'GRANJAS MODERNAS',
    postal_code: '7460',
    phone: '',
    latitude: '19.4819177',
    longitude: '-99.1236702',
  },
  {
    name: "Innovasport Galerías Mty",
    state: "NUEVO LEON",
    alcaldia: "MONTERREY",
    calle: "AV INSURGENTES #2500 ",
    local: "822",
    colonia: "VISTA HERMOSA",
    postal_code: "64620",
    phone: "",
    latitude: "25.6828172",
    longitude: "-100.359205",
  },
  {
    name: "Poblano Sport",
    state: "Nuevo León",
    alcaldia: "Monterrey",
    calle: "Rafael Platón Sánchez 712 Nte.",
    local: "-",
    colonia: "Centro",
    postal_code: "64000",
    phone: "(81) 8312-1048",
    latitude: "19.3028607",
    longitude: "-99.1527164",
  },
  {
    name: "POBLANO SPORT Saltillo",
    state: "COAHUILA",
    alcaldia: "SALTILLO",
    calle: "Torreón #2047",
    local: "-",
    colonia: "República",
    postal_code: "25280",
    phone: "-",
    latitude: "25.4392276",
    longitude: "-100.9942336",
  },
  {
    name: "SALVAJES",
    state: "SAN LUIS POTOSÍ",
    alcaldia: "SAN LUIS POTOSÍ",
    calle: "Avenida Parque Chapultepec #1000",
    local: "13",
    colonia: "Parque",
    postal_code: "78294",
    phone: "-",
    latitude: "22.12833",
    longitude: "-101.0176462",
  },
  {
    name: "Deportes Hugo",
    state: "Oaxaca",
    alcaldia: "Santa Lucia del Camino",
    calle: "CARRETERA CRISTOBAL COLON 1420",
    local: "-",
    colonia: "SANTA MARIA IXCOTEL",
    postal_code: "71244",
    phone: "951 513 3000",
    latitude: "17.078221",
    longitude: "-96.7005264",
  },
  {
    name: 'Tienda DelMaz CDMX Anzures',
    state: 'CDMX',
    alcaldia: 'Miguel Hidalgo',
    calle: 'Mariano Escobedo 748',
    local: '',
    colonia: 'Anzures',
    postal_code: '11590',
    phone: '',
    latitude: '19.4255682',
    longitude: '-99.1828393',
  },
  {
    name: 'Tienda DelMaz Town Square Metepec',
    state: 'Estado de México',
    alcaldia: 'Metepec',
    calle: 'Ignacio Comonfort 1100 ',
    local: 'G203',
    colonia: 'La Providencia',
    postal_code: '52177',
    phone: '',
    latitude: '19.2671697',
    longitude: '-99.6079788',
  },
  {
    name: 'Tienda DelMaz Guadalajara',
    state: 'Jalisco',
    alcaldia: 'Guadalajara',
    calle: 'Pablo Neruda # 2365 ',
    local: '8',
    colonia: 'Providencia',
    postal_code: '44630',
    phone: '',
    latitude: '20.6979306',
    longitude: '-103.3792666',
  },
  {
    name: 'Tienda DelMaz Marina Puerto Cancun',
    state: 'Quintana Roo',
    alcaldia: 'Cancún',
    calle: 'Blvd Kukulkán1 Loc A04C Secc E',
    local: '',
    colonia: 'Benito Juarez',
    postal_code: '77500',
    phone: '',
    latitude: '21.1609728',
    longitude: '-86.8107179',
  },
  {
    name: 'Oficinas DelMaz Monterrey',
    state: 'Nuevo León',
    alcaldia: 'Monterrey',
    calle: 'Anillo Periférico 1639',
    local: '3',
    colonia: 'Rincón de San Jerónimo',
    postal_code: '64637',
    phone: '',
    latitude: '25.6906467',
    longitude: '-100.3791101',
  },
];
